module.exports = __webpack_public_path__ + "img/oeeBlue.deab20ef.svg";